import React, { useContext, Suspense } from "react";
import Loader, { LoaderScreen } from "../components/Loader";
import Context from "../context/AppContext";

const PrincipalCard = React.lazy(() => import("../components/PrincipalCard"));
const ListOfCards = React.lazy(() => import("../components/ListOfCards"));

const Home = () => {
  const { anime, initialState } = useContext(Context);
  return (
    <div className="home">
      <Suspense
        fallback={
          <LoaderScreen>
            <Loader />
          </LoaderScreen>
        }
      >
        <PrincipalCard anime={anime} />
        <ListOfCards initialState={initialState} />
      </Suspense>
    </div>
  );
};

export default Home;
